export default (node) => {
  $('#hover-node-card .card-header').text(node.name)

  const title = node.data.title || ''
  const postbackId = node.data.postbackId || ''

  const labelIds = node.data.labelIds || []
  const labelIdTextsArray = node.data.labelIdTextsArray || []

  const sequenceIdValue = node.data.sequenceIdValue || ''
  const sequenceIdText = node.data.sequenceIdText || ''

  let html = `<p class="card-text"><strong>Title</strong>: ${title}</p>`
  html += '<p class="card-text"><strong>Postback ID</strong>: ' + postbackId + '</p>'

  if ((labelIds.length > 0) && (labelIdTextsArray.length > 0)) {
    const labelIdTextsArrayAsString = labelIdTextsArray.join(', ')
    html += `<p><strong>Label IDs:</strong> ${labelIdTextsArrayAsString}</p>`
  }
  
  if (sequenceIdValue && sequenceIdText) {
    html += `<p><strong>Sequence ID:</strong> ${sequenceIdText}</p>`
  } 

  if (! title && ! postbackId) {
    $('#hover-node-card .card-body').html('')
  } else {
    $('#hover-node-card .card-body').html(html)
  }
}